import {Buttonv2 as Button, Inputv2 as Input} from '@logistics-frontend/blocks/v2'
import {useI18n} from '@logistics-frontend/core/i18n'
import {AsyncStatus, useCouponActivateRequest} from '@yandex-taxi/react-integration-api'
import React, {useCallback, useState} from 'react'

import {classes} from './CouponActivationField.classes'

const CouponActivationField: React.FC = () => {
  const t = useI18n()
  const [activateHandler, {data, status, error}] = useCouponActivateRequest()
  const [value, setValue] = useState('')
  const clearHandler = useCallback(() => setValue(''), [])
  const changeHandler = useCallback((value: string) => setValue(value), [])
  const clickHandler = useCallback(() => activateHandler(value), [activateHandler, value])
  const errorText = (function getError() {
    if (status === AsyncStatus.SUCCESS && data && 'coupon' in data) {
      return data.coupon.error?.description
    }

    if (status === AsyncStatus.ERROR) {
      return error?.message || t('order.form.coupons.unknown_coupon_error', 'Неизвестный промокод')
    }
  })()
  const loading = status === AsyncStatus.PENDING
  const disabled = loading || !value

  return (
    <>
      <Input
        className={classes.input}
        error={!!errorText}
        helperText={errorText}
        onChange={changeHandler}
        placeholder={t('order.form.coupons.new_coupon', 'Новый промокод')}
        trail={
          value ? (
            <button className={classes.smallRemoveButton} onClick={clearHandler}>
              ✕
            </button>
          ) : undefined
        }
        value={value}
      />
      <Button
        className={classes.actionButton}
        disabled={disabled}
        loading={loading}
        onPress={clickHandler}
        variant="action"
        fullWidth
      >
        {t('order.form.coupons.activate', 'Активировать')}
      </Button>
    </>
  )
}

export default CouponActivationField
